import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../wayfinder'
import recipients from './recipients'
import segments from './segments'
import tags from './tags'
import settings69f00b from './settings'
/**
* @see \App\Http\Controllers\Creator\CampaignController::index
* @see app/Http/Controllers/Creator/CampaignController.php:35
* @route '/app/creator/campaigns'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/app/creator/campaigns',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Creator\CampaignController::index
* @see app/Http/Controllers/Creator/CampaignController.php:35
* @route '/app/creator/campaigns'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Creator\CampaignController::index
* @see app/Http/Controllers/Creator/CampaignController.php:35
* @route '/app/creator/campaigns'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Creator\CampaignController::index
* @see app/Http/Controllers/Creator/CampaignController.php:35
* @route '/app/creator/campaigns'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Creator\CampaignController::index
* @see app/Http/Controllers/Creator/CampaignController.php:35
* @route '/app/creator/campaigns'
*/
const indexForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Creator\CampaignController::index
* @see app/Http/Controllers/Creator/CampaignController.php:35
* @route '/app/creator/campaigns'
*/
indexForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Creator\CampaignController::index
* @see app/Http/Controllers/Creator/CampaignController.php:35
* @route '/app/creator/campaigns'
*/
indexForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

index.form = indexForm

/**
* @see \App\Http\Controllers\Creator\CampaignController::create
* @see app/Http/Controllers/Creator/CampaignController.php:153
* @route '/app/creator/campaigns/create'
*/
export const create = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: create.url(options),
    method: 'get',
})

create.definition = {
    methods: ["get","head"],
    url: '/app/creator/campaigns/create',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Creator\CampaignController::create
* @see app/Http/Controllers/Creator/CampaignController.php:153
* @route '/app/creator/campaigns/create'
*/
create.url = (options?: RouteQueryOptions) => {
    return create.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Creator\CampaignController::create
* @see app/Http/Controllers/Creator/CampaignController.php:153
* @route '/app/creator/campaigns/create'
*/
create.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: create.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Creator\CampaignController::create
* @see app/Http/Controllers/Creator/CampaignController.php:153
* @route '/app/creator/campaigns/create'
*/
create.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: create.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Creator\CampaignController::create
* @see app/Http/Controllers/Creator/CampaignController.php:153
* @route '/app/creator/campaigns/create'
*/
const createForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: create.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Creator\CampaignController::create
* @see app/Http/Controllers/Creator/CampaignController.php:153
* @route '/app/creator/campaigns/create'
*/
createForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: create.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Creator\CampaignController::create
* @see app/Http/Controllers/Creator/CampaignController.php:153
* @route '/app/creator/campaigns/create'
*/
createForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: create.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

create.form = createForm

/**
* @see \App\Http\Controllers\Creator\CampaignController::store
* @see app/Http/Controllers/Creator/CampaignController.php:167
* @route '/app/creator/campaigns'
*/
export const store = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '/app/creator/campaigns',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Creator\CampaignController::store
* @see app/Http/Controllers/Creator/CampaignController.php:167
* @route '/app/creator/campaigns'
*/
store.url = (options?: RouteQueryOptions) => {
    return store.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Creator\CampaignController::store
* @see app/Http/Controllers/Creator/CampaignController.php:167
* @route '/app/creator/campaigns'
*/
store.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Creator\CampaignController::store
* @see app/Http/Controllers/Creator/CampaignController.php:167
* @route '/app/creator/campaigns'
*/
const storeForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Creator\CampaignController::store
* @see app/Http/Controllers/Creator/CampaignController.php:167
* @route '/app/creator/campaigns'
*/
storeForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

store.form = storeForm

/**
* @see \App\Http\Controllers\Creator\CampaignController::show
* @see app/Http/Controllers/Creator/CampaignController.php:256
* @route '/app/creator/campaigns/{campaign}'
*/
export const show = (args: { campaign: string | { uuid: string } } | [campaign: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

show.definition = {
    methods: ["get","head"],
    url: '/app/creator/campaigns/{campaign}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Creator\CampaignController::show
* @see app/Http/Controllers/Creator/CampaignController.php:256
* @route '/app/creator/campaigns/{campaign}'
*/
show.url = (args: { campaign: string | { uuid: string } } | [campaign: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { campaign: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'uuid' in args) {
        args = { campaign: args.uuid }
    }

    if (Array.isArray(args)) {
        args = {
            campaign: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        campaign: typeof args.campaign === 'object'
        ? args.campaign.uuid
        : args.campaign,
    }

    return show.definition.url
            .replace('{campaign}', parsedArgs.campaign.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Creator\CampaignController::show
* @see app/Http/Controllers/Creator/CampaignController.php:256
* @route '/app/creator/campaigns/{campaign}'
*/
show.get = (args: { campaign: string | { uuid: string } } | [campaign: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Creator\CampaignController::show
* @see app/Http/Controllers/Creator/CampaignController.php:256
* @route '/app/creator/campaigns/{campaign}'
*/
show.head = (args: { campaign: string | { uuid: string } } | [campaign: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: show.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Creator\CampaignController::show
* @see app/Http/Controllers/Creator/CampaignController.php:256
* @route '/app/creator/campaigns/{campaign}'
*/
const showForm = (args: { campaign: string | { uuid: string } } | [campaign: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Creator\CampaignController::show
* @see app/Http/Controllers/Creator/CampaignController.php:256
* @route '/app/creator/campaigns/{campaign}'
*/
showForm.get = (args: { campaign: string | { uuid: string } } | [campaign: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Creator\CampaignController::show
* @see app/Http/Controllers/Creator/CampaignController.php:256
* @route '/app/creator/campaigns/{campaign}'
*/
showForm.head = (args: { campaign: string | { uuid: string } } | [campaign: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

show.form = showForm

/**
* @see \App\Http\Controllers\Creator\CampaignController::edit
* @see app/Http/Controllers/Creator/CampaignController.php:192
* @route '/app/creator/campaigns/{campaign}/edit'
*/
export const edit = (args: { campaign: string | { uuid: string } } | [campaign: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: edit.url(args, options),
    method: 'get',
})

edit.definition = {
    methods: ["get","head"],
    url: '/app/creator/campaigns/{campaign}/edit',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Creator\CampaignController::edit
* @see app/Http/Controllers/Creator/CampaignController.php:192
* @route '/app/creator/campaigns/{campaign}/edit'
*/
edit.url = (args: { campaign: string | { uuid: string } } | [campaign: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { campaign: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'uuid' in args) {
        args = { campaign: args.uuid }
    }

    if (Array.isArray(args)) {
        args = {
            campaign: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        campaign: typeof args.campaign === 'object'
        ? args.campaign.uuid
        : args.campaign,
    }

    return edit.definition.url
            .replace('{campaign}', parsedArgs.campaign.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Creator\CampaignController::edit
* @see app/Http/Controllers/Creator/CampaignController.php:192
* @route '/app/creator/campaigns/{campaign}/edit'
*/
edit.get = (args: { campaign: string | { uuid: string } } | [campaign: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: edit.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Creator\CampaignController::edit
* @see app/Http/Controllers/Creator/CampaignController.php:192
* @route '/app/creator/campaigns/{campaign}/edit'
*/
edit.head = (args: { campaign: string | { uuid: string } } | [campaign: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: edit.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Creator\CampaignController::edit
* @see app/Http/Controllers/Creator/CampaignController.php:192
* @route '/app/creator/campaigns/{campaign}/edit'
*/
const editForm = (args: { campaign: string | { uuid: string } } | [campaign: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: edit.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Creator\CampaignController::edit
* @see app/Http/Controllers/Creator/CampaignController.php:192
* @route '/app/creator/campaigns/{campaign}/edit'
*/
editForm.get = (args: { campaign: string | { uuid: string } } | [campaign: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: edit.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Creator\CampaignController::edit
* @see app/Http/Controllers/Creator/CampaignController.php:192
* @route '/app/creator/campaigns/{campaign}/edit'
*/
editForm.head = (args: { campaign: string | { uuid: string } } | [campaign: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: edit.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

edit.form = editForm

/**
* @see \App\Http\Controllers\Creator\CampaignController::update
* @see app/Http/Controllers/Creator/CampaignController.php:219
* @route '/app/creator/campaigns/{campaign}'
*/
export const update = (args: { campaign: string | { uuid: string } } | [campaign: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

update.definition = {
    methods: ["put","patch"],
    url: '/app/creator/campaigns/{campaign}',
} satisfies RouteDefinition<["put","patch"]>

/**
* @see \App\Http\Controllers\Creator\CampaignController::update
* @see app/Http/Controllers/Creator/CampaignController.php:219
* @route '/app/creator/campaigns/{campaign}'
*/
update.url = (args: { campaign: string | { uuid: string } } | [campaign: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { campaign: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'uuid' in args) {
        args = { campaign: args.uuid }
    }

    if (Array.isArray(args)) {
        args = {
            campaign: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        campaign: typeof args.campaign === 'object'
        ? args.campaign.uuid
        : args.campaign,
    }

    return update.definition.url
            .replace('{campaign}', parsedArgs.campaign.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Creator\CampaignController::update
* @see app/Http/Controllers/Creator/CampaignController.php:219
* @route '/app/creator/campaigns/{campaign}'
*/
update.put = (args: { campaign: string | { uuid: string } } | [campaign: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

/**
* @see \App\Http\Controllers\Creator\CampaignController::update
* @see app/Http/Controllers/Creator/CampaignController.php:219
* @route '/app/creator/campaigns/{campaign}'
*/
update.patch = (args: { campaign: string | { uuid: string } } | [campaign: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: update.url(args, options),
    method: 'patch',
})

/**
* @see \App\Http\Controllers\Creator\CampaignController::update
* @see app/Http/Controllers/Creator/CampaignController.php:219
* @route '/app/creator/campaigns/{campaign}'
*/
const updateForm = (args: { campaign: string | { uuid: string } } | [campaign: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Creator\CampaignController::update
* @see app/Http/Controllers/Creator/CampaignController.php:219
* @route '/app/creator/campaigns/{campaign}'
*/
updateForm.put = (args: { campaign: string | { uuid: string } } | [campaign: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Creator\CampaignController::update
* @see app/Http/Controllers/Creator/CampaignController.php:219
* @route '/app/creator/campaigns/{campaign}'
*/
updateForm.patch = (args: { campaign: string | { uuid: string } } | [campaign: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PATCH',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

update.form = updateForm

/**
* @see \App\Http\Controllers\Creator\CampaignController::destroy
* @see app/Http/Controllers/Creator/CampaignController.php:492
* @route '/app/creator/campaigns/{campaign}'
*/
export const destroy = (args: { campaign: string | { uuid: string } } | [campaign: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: '/app/creator/campaigns/{campaign}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Creator\CampaignController::destroy
* @see app/Http/Controllers/Creator/CampaignController.php:492
* @route '/app/creator/campaigns/{campaign}'
*/
destroy.url = (args: { campaign: string | { uuid: string } } | [campaign: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { campaign: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'uuid' in args) {
        args = { campaign: args.uuid }
    }

    if (Array.isArray(args)) {
        args = {
            campaign: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        campaign: typeof args.campaign === 'object'
        ? args.campaign.uuid
        : args.campaign,
    }

    return destroy.definition.url
            .replace('{campaign}', parsedArgs.campaign.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Creator\CampaignController::destroy
* @see app/Http/Controllers/Creator/CampaignController.php:492
* @route '/app/creator/campaigns/{campaign}'
*/
destroy.delete = (args: { campaign: string | { uuid: string } } | [campaign: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\Creator\CampaignController::destroy
* @see app/Http/Controllers/Creator/CampaignController.php:492
* @route '/app/creator/campaigns/{campaign}'
*/
const destroyForm = (args: { campaign: string | { uuid: string } } | [campaign: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Creator\CampaignController::destroy
* @see app/Http/Controllers/Creator/CampaignController.php:492
* @route '/app/creator/campaigns/{campaign}'
*/
destroyForm.delete = (args: { campaign: string | { uuid: string } } | [campaign: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

destroy.form = destroyForm

/**
* @see \App\Http\Controllers\Creator\CampaignController::send
* @see app/Http/Controllers/Creator/CampaignController.php:319
* @route '/app/creator/campaigns/{campaign}/send'
*/
export const send = (args: { campaign: string | { uuid: string } } | [campaign: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: send.url(args, options),
    method: 'post',
})

send.definition = {
    methods: ["post"],
    url: '/app/creator/campaigns/{campaign}/send',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Creator\CampaignController::send
* @see app/Http/Controllers/Creator/CampaignController.php:319
* @route '/app/creator/campaigns/{campaign}/send'
*/
send.url = (args: { campaign: string | { uuid: string } } | [campaign: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { campaign: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'uuid' in args) {
        args = { campaign: args.uuid }
    }

    if (Array.isArray(args)) {
        args = {
            campaign: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        campaign: typeof args.campaign === 'object'
        ? args.campaign.uuid
        : args.campaign,
    }

    return send.definition.url
            .replace('{campaign}', parsedArgs.campaign.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Creator\CampaignController::send
* @see app/Http/Controllers/Creator/CampaignController.php:319
* @route '/app/creator/campaigns/{campaign}/send'
*/
send.post = (args: { campaign: string | { uuid: string } } | [campaign: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: send.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Creator\CampaignController::send
* @see app/Http/Controllers/Creator/CampaignController.php:319
* @route '/app/creator/campaigns/{campaign}/send'
*/
const sendForm = (args: { campaign: string | { uuid: string } } | [campaign: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: send.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Creator\CampaignController::send
* @see app/Http/Controllers/Creator/CampaignController.php:319
* @route '/app/creator/campaigns/{campaign}/send'
*/
sendForm.post = (args: { campaign: string | { uuid: string } } | [campaign: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: send.url(args, options),
    method: 'post',
})

send.form = sendForm

/**
* @see \App\Http\Controllers\Creator\CampaignController::cancel
* @see app/Http/Controllers/Creator/CampaignController.php:376
* @route '/app/creator/campaigns/{campaign}/cancel'
*/
export const cancel = (args: { campaign: string | { uuid: string } } | [campaign: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: cancel.url(args, options),
    method: 'post',
})

cancel.definition = {
    methods: ["post"],
    url: '/app/creator/campaigns/{campaign}/cancel',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Creator\CampaignController::cancel
* @see app/Http/Controllers/Creator/CampaignController.php:376
* @route '/app/creator/campaigns/{campaign}/cancel'
*/
cancel.url = (args: { campaign: string | { uuid: string } } | [campaign: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { campaign: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'uuid' in args) {
        args = { campaign: args.uuid }
    }

    if (Array.isArray(args)) {
        args = {
            campaign: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        campaign: typeof args.campaign === 'object'
        ? args.campaign.uuid
        : args.campaign,
    }

    return cancel.definition.url
            .replace('{campaign}', parsedArgs.campaign.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Creator\CampaignController::cancel
* @see app/Http/Controllers/Creator/CampaignController.php:376
* @route '/app/creator/campaigns/{campaign}/cancel'
*/
cancel.post = (args: { campaign: string | { uuid: string } } | [campaign: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: cancel.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Creator\CampaignController::cancel
* @see app/Http/Controllers/Creator/CampaignController.php:376
* @route '/app/creator/campaigns/{campaign}/cancel'
*/
const cancelForm = (args: { campaign: string | { uuid: string } } | [campaign: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: cancel.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Creator\CampaignController::cancel
* @see app/Http/Controllers/Creator/CampaignController.php:376
* @route '/app/creator/campaigns/{campaign}/cancel'
*/
cancelForm.post = (args: { campaign: string | { uuid: string } } | [campaign: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: cancel.url(args, options),
    method: 'post',
})

cancel.form = cancelForm

/**
* @see \App\Http\Controllers\Creator\CampaignController::pause
* @see app/Http/Controllers/Creator/CampaignController.php:394
* @route '/app/creator/campaigns/{campaign}/pause'
*/
export const pause = (args: { campaign: string | { uuid: string } } | [campaign: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: pause.url(args, options),
    method: 'post',
})

pause.definition = {
    methods: ["post"],
    url: '/app/creator/campaigns/{campaign}/pause',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Creator\CampaignController::pause
* @see app/Http/Controllers/Creator/CampaignController.php:394
* @route '/app/creator/campaigns/{campaign}/pause'
*/
pause.url = (args: { campaign: string | { uuid: string } } | [campaign: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { campaign: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'uuid' in args) {
        args = { campaign: args.uuid }
    }

    if (Array.isArray(args)) {
        args = {
            campaign: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        campaign: typeof args.campaign === 'object'
        ? args.campaign.uuid
        : args.campaign,
    }

    return pause.definition.url
            .replace('{campaign}', parsedArgs.campaign.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Creator\CampaignController::pause
* @see app/Http/Controllers/Creator/CampaignController.php:394
* @route '/app/creator/campaigns/{campaign}/pause'
*/
pause.post = (args: { campaign: string | { uuid: string } } | [campaign: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: pause.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Creator\CampaignController::pause
* @see app/Http/Controllers/Creator/CampaignController.php:394
* @route '/app/creator/campaigns/{campaign}/pause'
*/
const pauseForm = (args: { campaign: string | { uuid: string } } | [campaign: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: pause.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Creator\CampaignController::pause
* @see app/Http/Controllers/Creator/CampaignController.php:394
* @route '/app/creator/campaigns/{campaign}/pause'
*/
pauseForm.post = (args: { campaign: string | { uuid: string } } | [campaign: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: pause.url(args, options),
    method: 'post',
})

pause.form = pauseForm

/**
* @see \App\Http\Controllers\Creator\CampaignController::resume
* @see app/Http/Controllers/Creator/CampaignController.php:407
* @route '/app/creator/campaigns/{campaign}/resume'
*/
export const resume = (args: { campaign: string | { uuid: string } } | [campaign: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: resume.url(args, options),
    method: 'post',
})

resume.definition = {
    methods: ["post"],
    url: '/app/creator/campaigns/{campaign}/resume',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Creator\CampaignController::resume
* @see app/Http/Controllers/Creator/CampaignController.php:407
* @route '/app/creator/campaigns/{campaign}/resume'
*/
resume.url = (args: { campaign: string | { uuid: string } } | [campaign: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { campaign: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'uuid' in args) {
        args = { campaign: args.uuid }
    }

    if (Array.isArray(args)) {
        args = {
            campaign: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        campaign: typeof args.campaign === 'object'
        ? args.campaign.uuid
        : args.campaign,
    }

    return resume.definition.url
            .replace('{campaign}', parsedArgs.campaign.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Creator\CampaignController::resume
* @see app/Http/Controllers/Creator/CampaignController.php:407
* @route '/app/creator/campaigns/{campaign}/resume'
*/
resume.post = (args: { campaign: string | { uuid: string } } | [campaign: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: resume.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Creator\CampaignController::resume
* @see app/Http/Controllers/Creator/CampaignController.php:407
* @route '/app/creator/campaigns/{campaign}/resume'
*/
const resumeForm = (args: { campaign: string | { uuid: string } } | [campaign: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: resume.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Creator\CampaignController::resume
* @see app/Http/Controllers/Creator/CampaignController.php:407
* @route '/app/creator/campaigns/{campaign}/resume'
*/
resumeForm.post = (args: { campaign: string | { uuid: string } } | [campaign: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: resume.url(args, options),
    method: 'post',
})

resume.form = resumeForm

/**
* @see \App\Http\Controllers\Creator\CampaignController::duplicate
* @see app/Http/Controllers/Creator/CampaignController.php:465
* @route '/app/creator/campaigns/{campaign}/duplicate'
*/
export const duplicate = (args: { campaign: string | { uuid: string } } | [campaign: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: duplicate.url(args, options),
    method: 'post',
})

duplicate.definition = {
    methods: ["post"],
    url: '/app/creator/campaigns/{campaign}/duplicate',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Creator\CampaignController::duplicate
* @see app/Http/Controllers/Creator/CampaignController.php:465
* @route '/app/creator/campaigns/{campaign}/duplicate'
*/
duplicate.url = (args: { campaign: string | { uuid: string } } | [campaign: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { campaign: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'uuid' in args) {
        args = { campaign: args.uuid }
    }

    if (Array.isArray(args)) {
        args = {
            campaign: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        campaign: typeof args.campaign === 'object'
        ? args.campaign.uuid
        : args.campaign,
    }

    return duplicate.definition.url
            .replace('{campaign}', parsedArgs.campaign.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Creator\CampaignController::duplicate
* @see app/Http/Controllers/Creator/CampaignController.php:465
* @route '/app/creator/campaigns/{campaign}/duplicate'
*/
duplicate.post = (args: { campaign: string | { uuid: string } } | [campaign: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: duplicate.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Creator\CampaignController::duplicate
* @see app/Http/Controllers/Creator/CampaignController.php:465
* @route '/app/creator/campaigns/{campaign}/duplicate'
*/
const duplicateForm = (args: { campaign: string | { uuid: string } } | [campaign: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: duplicate.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Creator\CampaignController::duplicate
* @see app/Http/Controllers/Creator/CampaignController.php:465
* @route '/app/creator/campaigns/{campaign}/duplicate'
*/
duplicateForm.post = (args: { campaign: string | { uuid: string } } | [campaign: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: duplicate.url(args, options),
    method: 'post',
})

duplicate.form = duplicateForm

/**
* @see \App\Http\Controllers\Creator\CampaignController::preview
* @see app/Http/Controllers/Creator/CampaignController.php:431
* @route '/app/creator/campaigns/{campaign}/preview'
*/
export const preview = (args: { campaign: string | { uuid: string } } | [campaign: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: preview.url(args, options),
    method: 'post',
})

preview.definition = {
    methods: ["post"],
    url: '/app/creator/campaigns/{campaign}/preview',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Creator\CampaignController::preview
* @see app/Http/Controllers/Creator/CampaignController.php:431
* @route '/app/creator/campaigns/{campaign}/preview'
*/
preview.url = (args: { campaign: string | { uuid: string } } | [campaign: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { campaign: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'uuid' in args) {
        args = { campaign: args.uuid }
    }

    if (Array.isArray(args)) {
        args = {
            campaign: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        campaign: typeof args.campaign === 'object'
        ? args.campaign.uuid
        : args.campaign,
    }

    return preview.definition.url
            .replace('{campaign}', parsedArgs.campaign.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Creator\CampaignController::preview
* @see app/Http/Controllers/Creator/CampaignController.php:431
* @route '/app/creator/campaigns/{campaign}/preview'
*/
preview.post = (args: { campaign: string | { uuid: string } } | [campaign: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: preview.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Creator\CampaignController::preview
* @see app/Http/Controllers/Creator/CampaignController.php:431
* @route '/app/creator/campaigns/{campaign}/preview'
*/
const previewForm = (args: { campaign: string | { uuid: string } } | [campaign: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: preview.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Creator\CampaignController::preview
* @see app/Http/Controllers/Creator/CampaignController.php:431
* @route '/app/creator/campaigns/{campaign}/preview'
*/
previewForm.post = (args: { campaign: string | { uuid: string } } | [campaign: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: preview.url(args, options),
    method: 'post',
})

preview.form = previewForm

/**
* @see \App\Http\Controllers\Creator\SendingDomainController::settings
* @see app/Http/Controllers/Creator/SendingDomainController.php:31
* @route '/app/creator/campaigns-settings'
*/
export const settings = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: settings.url(options),
    method: 'get',
})

settings.definition = {
    methods: ["get","head"],
    url: '/app/creator/campaigns-settings',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Creator\SendingDomainController::settings
* @see app/Http/Controllers/Creator/SendingDomainController.php:31
* @route '/app/creator/campaigns-settings'
*/
settings.url = (options?: RouteQueryOptions) => {
    return settings.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Creator\SendingDomainController::settings
* @see app/Http/Controllers/Creator/SendingDomainController.php:31
* @route '/app/creator/campaigns-settings'
*/
settings.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: settings.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Creator\SendingDomainController::settings
* @see app/Http/Controllers/Creator/SendingDomainController.php:31
* @route '/app/creator/campaigns-settings'
*/
settings.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: settings.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Creator\SendingDomainController::settings
* @see app/Http/Controllers/Creator/SendingDomainController.php:31
* @route '/app/creator/campaigns-settings'
*/
const settingsForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: settings.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Creator\SendingDomainController::settings
* @see app/Http/Controllers/Creator/SendingDomainController.php:31
* @route '/app/creator/campaigns-settings'
*/
settingsForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: settings.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Creator\SendingDomainController::settings
* @see app/Http/Controllers/Creator/SendingDomainController.php:31
* @route '/app/creator/campaigns-settings'
*/
settingsForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: settings.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

settings.form = settingsForm

const campaigns = {
    index: Object.assign(index, index),
    create: Object.assign(create, create),
    store: Object.assign(store, store),
    show: Object.assign(show, show),
    edit: Object.assign(edit, edit),
    update: Object.assign(update, update),
    destroy: Object.assign(destroy, destroy),
    send: Object.assign(send, send),
    cancel: Object.assign(cancel, cancel),
    pause: Object.assign(pause, pause),
    resume: Object.assign(resume, resume),
    duplicate: Object.assign(duplicate, duplicate),
    preview: Object.assign(preview, preview),
    recipients: Object.assign(recipients, recipients),
    segments: Object.assign(segments, segments),
    tags: Object.assign(tags, tags),
    settings: Object.assign(settings, settings69f00b),
}

export default campaigns